import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const typographyConfig = capitalDesignTokens.foundations.typography;
const getFontStyles = (fontSizeKey, fontWeight = "normal") => {
  return {
    fontSize: typographyConfig.fontSize[fontSizeKey],
    lineHeight: typographyConfig.lineHeight[fontSizeKey],
    fontWeight: typographyConfig.fontWeight[fontWeight],
    fontFamily: typographyConfig.baseFont,
    fontFeatureSettings: "'ss03' on"
  };
};
const typography = {
  fontFamily: typographyConfig.baseFont,
  h1: getFontStyles("h1", "semiBold"),
  h2: getFontStyles("h2", "semiBold"),
  h3: getFontStyles("h3", "semiBold"),
  h4: getFontStyles("h4", "semiBold"),
  h5: getFontStyles("h5", "semiBold"),
  h6: getFontStyles("h6", "semiBold"),
  d1: getFontStyles("displayXLarge", "light"),
  d2: getFontStyles("displayLarge", "light"),
  d3: getFontStyles("displayMedium", "light"),
  d4: getFontStyles("displaySmall", "light"),
  d5: getFontStyles("displayXSmall", "light"),
  d6: getFontStyles("displayXXSmall", "light"),
  body1: getFontStyles("bodyDefault"),
  body2: getFontStyles("bodySmall"),
  button: { ...getFontStyles("bodyDefault", "semiBold"), textTransform: "none" },
  overline: getFontStyles("bodySmall", "medium"),
  bodyXLarge: getFontStyles("bodyXLarge"),
  bodyLarge: getFontStyles("bodyLarge"),
  bodyDefault: getFontStyles("bodyDefault"),
  bodySmall: getFontStyles("bodySmall"),
  bodyXSmall: getFontStyles("bodyXSmall"),
  fontWeightSemiBold: typographyConfig.fontWeight.semiBold
};
const getTypography = (palette) => ({
  ...typography,
  overline: { ...typography.overline, color: palette.text.secondary }
});
export {
  getFontStyles,
  getTypography,
  typography
};
//# sourceMappingURL=typography.js.map
